import React from "react";

import { Route, RouteComponentProps } from "react-router-dom";

import { SolutionsHome } from "./SolutionsHome";
import { AutomateAC } from "./AutomateAC";
import { AutomateConsumerMonitoring } from "./AutomateConsumerMonitoring";
import { AutomateProsumer } from "./AutomateProsumer";
import { AutomateProsumerEnd } from "./AutomateProsumerEnd";
import { GreenEnergyContracts } from "./GreenEnergyContracts";
import { GreenEnergyUnavailable } from "./GreenEnergyUnavailable";
import { GreenEnergyCallback } from "./GreenEnergyCallback";
import { GreenEnergyCongrats } from "./GreenEnergyCongrats";
import { Diagnosis } from "./Diagnosis";
import { DiagnosisCongrats } from "./DiagnosisCongrats";
import { Simulator } from "./Simulator";
import { SimulatorResults } from "./SimulatorResults";
import { GreenEnergySigned } from "./GreenEnergySigned";
import { DevicesRouter } from "./devices";

export const SolutionsRouter = ({ match: { path } }: RouteComponentProps) => {
  return (
    <>
      <Route exact path={`${path}/`} component={SolutionsHome} />
      <Route exact path={`${path}/automate-ac`} component={AutomateAC} />
      <Route
        exact
        path={`${path}/automate-consumer-monitoring`}
        component={AutomateConsumerMonitoring}
      />
      <Route
        exact
        path={`${path}/prosumer-credentials`}
        component={AutomateProsumer}
      />
      <Route
        exact
        path={`${path}/prosumer-credentials-end`}
        component={AutomateProsumerEnd}
      />
      <Route
        exact
        path={`${path}/green-energy-contracts`}
        component={GreenEnergyContracts}
      />
      <Route
        exact
        path={`${path}/green-energy-unavailable`}
        component={GreenEnergyUnavailable}
      />
      <Route
        exact
        path={`${path}/green-energy-callback`}
        component={GreenEnergyCallback}
      />
      <Route
        exact
        path={`${path}/green-energy-congrats`}
        component={GreenEnergyCongrats}
      />
      <Route
        exact
        path={`${path}/green-energy-signed`}
        component={GreenEnergySigned}
      />
      <Route exact path={`${path}/diagnosis`} component={Diagnosis} />
      <Route
        exact
        path={`${path}/diagnosis-congrats`}
        component={DiagnosisCongrats}
      />
      <Route exact path={`${path}/simulator`} component={Simulator} />
      <Route
        exact
        path={`${path}/simulator-results`}
        component={SimulatorResults}
      />
      <Route path={`${path}/devices`} component={DevicesRouter} />
    </>
  );
};
